/*
  custom.js — ported from the live theme, where global.js was edited to call
  applyColorChange() after Dawn swaps the variant-picker DOM. The function
  itself is defined in the product templates' Custom Liquid block and exposed
  as window.applyColorChange. This observer replaces that global.js edit so
  the vendor file can stay stock.
*/
(function () {
  var scheduled = false;

  function run() {
    scheduled = false;
    if (typeof window.applyColorChange === 'function') {
      window.applyColorChange();
    }
  }

  function isPickerSwap(mutation) {
    var nodes = Array.prototype.slice
      .call(mutation.addedNodes)
      .concat(Array.prototype.slice.call(mutation.removedNodes));
    return nodes.some(function (node) {
      if (node.nodeType !== 1) return false;
      if (node.matches('variant-selects, .product-form__input, product-info')) return true;
      return !!(node.querySelector && node.querySelector('variant-selects, .product-form__input'));
    });
  }

  function start() {
    if (!document.querySelector('variant-selects, .product-form__input')) return;
    new MutationObserver(function (mutations) {
      if (scheduled) return;
      if (mutations.some(isPickerSwap)) {
        scheduled = true;
        // matches the delay the live theme relied on (global.js removes the old node after 500ms)
        setTimeout(run, 600);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
